import badlandsLogo from '../../work/badlands-brewing/assets/badlands-logo-light.png';
import albumpickerLogo from './assets/album-picker.svg';
import lifetalesLogo from './assets/lifetales-logo.svg';
import rlLogo from './assets/car.png';
import gymTodoLogo from './assets/gym-todo.svg';
import scopaLogo from './assets/coin.svg';
import arcaneEyeSvg from './assets/arcane-eye.svg';
import queuetubeSvg from './assets/queuetube.svg';

const Projects = {
  druidWildShape: {
    name: 'Druid Wild Shape',
    skill: 'Web Dev',
    image: arcaneEyeSvg,
    backgroundColor: '#58180d'
  },
  lifetales: {
    name: 'LifeTales',
    skill: 'Dev & Design',
    image: lifetalesLogo,
  },
  gymtodo: {
    name: 'Gym Todo',
    skill: 'Web & App Dev',
    image: gymTodoLogo,
    backgroundColor: 'rgba(0,0,0,0.05)',
  },
  rlinventory: {
    name: 'Rocket League Item Inventory',
    skill: 'Web Dev',
    image: rlLogo,
  },
  scopa: {
    name: 'Scopa Calculator',
    skill: 'Web Dev',
    image: scopaLogo,
    backgroundColor: '#7496eb',
  },
  albumpicker: {
    name: 'Album Picker',
    skill: 'Dev & Design',
    image: albumpickerLogo,
    backgroundColor: '#062F70',
  },
  badlands: {
    name: 'Badlands Brewing',
    skill: 'Logo Design',
    image: badlandsLogo,
  },
  queuetube: {
    name: 'QueueTube',
    skill: 'Web Dev',
    image: queuetubeSvg,
    backgroundColor: '#FF0000',
  },
};

export default Projects;
